{
  "GENERAL": {
    "SHOWING_RESULTS": "Es mostren {firstIndex}-{lastIndex} de {totalCount} elements",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Cercar",
      "EMPTY_STATE": "No s'ha trobat agents"
    },
    "CLOSE": "Tanca",
    "BETA": "Beta",
    "BETA_DESCRIPTION": "This feature is in beta and may change as we improve it.",
    "ACCEPT": "Accept",
    "DISCARD": "Discard",
    "PREFERRED": "Preferred"
  },
  "CHOICE_TOGGLE": {
    "YES": "Si",
    "NO": "No"
  }
}
